import React from "react";
import { Trophy, Medal, SortAscending, SortDescending } from "@phosphor-icons/react";

export function LeagueTable({
  leagueTable,
  leagueSortOrder,
  onToggleSort,
  currentCategory,
  formatPrice
}) {
  const getRankDisplay = (rank) => {
    if (rank === 1) return <Trophy size={18} className="text-[#FCD34D]" weight="fill" />;
    if (rank === 2) return <Medal size={18} className="text-[#9CA3AF]" weight="fill" />;
    if (rank === 3) return <Medal size={18} className="text-[#CD7F32]" weight="fill" />;
    return <span className="text-[#6B7280] font-mono">{rank}</span>;
  };

  return (
    <div className="bg-[#111827] border border-[#1F2937]">
      <div className="p-4 border-b border-[#1F2937] flex items-center justify-between">
        <h2 className="font-serif text-xl text-white flex items-center gap-2">
          <Trophy size={24} className="text-[#FCD34D]" />
          County League Table
        </h2>
        <button
          onClick={onToggleSort}
          className="p-2 bg-[#1F2937] text-[#9CA3AF] hover:text-white transition-colors"
          title={leagueSortOrder === "desc" ? "Show Lowest First" : "Show Highest First"}
        >
          {leagueSortOrder === "desc" ? <SortDescending size={18} /> : <SortAscending size={18} />}
        </button>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#1F2937]">
            <tr>
              <th className="text-center px-3 py-3 text-xs font-mono uppercase text-[#6B7280] w-16">#</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-[#6B7280]">County</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-[#6B7280]">Province</th>
              <th className="text-right px-4 py-3 text-xs font-mono uppercase text-[#6B7280]">Avg Price</th>
              <th className="text-right px-4 py-3 text-xs font-mono uppercase text-[#059669]">Highest</th>
              <th className="text-right px-4 py-3 text-xs font-mono uppercase text-[#DC2626]">Lowest</th>
              <th className="text-center px-4 py-3 text-xs font-mono uppercase text-[#6B7280]">Marts</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#1F2937]">
            {leagueTable.map((county, idx) => (
              <tr 
                key={county.county}
                className={`hover:bg-[#1F2937] transition-colors ${idx < 3 ? 'bg-[#0F766E]/10' : ''}`}
              >
                <td className="px-3 py-3 text-center">
                  {getRankDisplay(idx + 1)}
                </td>
                <td className="px-4 py-3">
                  <span className="text-white text-sm font-medium">{county.county}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-[#6B7280] text-sm">{county.province}</span>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="font-mono text-sm text-[#14B8A6]">
                    {formatPrice(county.avg_price, currentCategory?.unit)}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="font-mono text-sm text-[#059669]">
                    {formatPrice(county.highest_price, currentCategory?.unit)}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <span className="font-mono text-sm text-[#DC2626]">
                    {formatPrice(county.lowest_price, currentCategory?.unit)}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-[#9CA3AF] font-mono">{county.mart_count}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LeagueTable;
